'use strict';
import angular from 'angular';

angular.module('ioreporting.flightsreport.services', ['core.iohelper'])
    .factory('FlightsReportFactory', FlightsReportFactory)
    .factory('FlightsReportDataGridFactory', FlightsReportDataGridFactory);

/**
 * @ngInject
 */
function FlightsReportFactory(
    Restangular,
    ColumnValueType
) {
    let FlightsReport = Restangular.all('flightsreports')
    let vars = FlightsReport.one('vars')
    let values = FlightsReport.one('values')

    /**
     *
     * @param queryParams
     * @returns {*|ICollectionPromise<T>|ICollectionPromise<any>|{method, params, headers}}
     */
    function getColumns(queryParams) {
        return FlightsReport.getList(_.extend({
            metadata: true,
            sort: 'label'
        }, queryParams));
    }

    /**
     * Get all selectable values for specific fields (enum values)
     * @param fields (fields can be undefined to fetch all)
     * @returns {*}
     */
    function getColumnValues(fields) {
        return values.one(ColumnValueType.SET).get(_.isUndefined(fields) ? '' : {fields: fields});
    }

    /**
     * Get all distinct values for specific fields
     * @param fields (fields can be undefined to fetch all)
     * @dataSource unused
     * @queryParams any additional query params
     * @returns {*}
     */
    function getFieldValues(fields, dataSource, queryParams) {
        return values.one(ColumnValueType.DISTINCT).get(
            _.extend(_.isUndefined(fields) ? {} : {fields: fields}, queryParams || {}));
    }

    /**
     * Get data for this resource
     * @param queryParams
     * @returns {*|ICollectionPromise<any>|ICollectionPromise<T>|{method, params, headers}}
     */
    function getData(queryParams) {
        return FlightsReport.getList(queryParams);
    }

    return {
        ecTasksSummary: FlightsReport,
        vars: vars,
        getColumns: getColumns,
        getColumnValues: getColumnValues,
        getFieldValues: getFieldValues,
        getData: getData
    }
}

/**
 * @ngInject
 */
function FlightsReportDataGridFactory(
    IODefaultLinkColumns,
    IODefaultLinkColumnsRenderer
) {
    return {
        getDTOptions: getDTOptions
    };

    /**
     * Return service specific datatable options
     * @returns {{}}
     */
    function getDTOptions() {
        let dtOptions = {};
        dtOptions.customRenders = {};
        dtOptions.customRenders[IODefaultLinkColumns.ORDER_ID] = IODefaultLinkColumnsRenderer.renderIoOrderIdLinkColumn
        dtOptions.customRenders[IODefaultLinkColumns.LINE_ITEM_ID] = IODefaultLinkColumnsRenderer.renderIoLineItemLinkColumn
        dtOptions.customRenders[IODefaultLinkColumns.FLIGHT_ID] = IODefaultLinkColumnsRenderer.renderIoFlightLinkColumn
        dtOptions.customRenders[IODefaultLinkColumns.TASK_ID] = IODefaultLinkColumnsRenderer.renderIoTaskLinkColumn;
        return dtOptions;
    }
}
